export default __webpack_public_path__ + "static/poster-45a34797da3811b6b1ca6bb610e47496.png";